// extracted by mini-css-extract-plugin
export default {"card":"styles_card__SeA76","content":"styles_content__WXqVR","bg":"styles_bg__drUMp","body":"styles_body__dODnD","logo":"styles_logo__x2sD+","cardFooter":"styles_cardFooter__k2r+g"};